import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export interface LessonStats {
  bestWpm: number;
  bestAccuracy: number;
  completedAt: string;
}

export interface UserProgress {
  name: string;
  completedLessons: number[];
  lessonStats: Record<number, LessonStats>;
}

type Screen =
  | { type: "login" }
  | { type: "lessons" }
  | { type: "typing"; lessonId: number }
  | { type: "review"; lessonId: number; wpm: number; accuracy: number };

// Persisted atoms — survive page refresh
export const progressAtom = atomWithStorage<UserProgress | null>(
  "typinglearnfun_progress",
  null,
);

export const screenAtom = atomWithStorage<Screen>(
  "typinglearnfun_screen",
  { type: "login" },
);

// Helpers (pure functions, no longer touch localStorage directly)
export function isLessonUnlocked(lessonId: number, progress: UserProgress): boolean {
  if (lessonId === 1) return true;
  return progress.completedLessons.includes(lessonId - 1);
}

export function buildLessonCompletion(
  progress: UserProgress,
  lessonId: number,
  wpm: number,
  accuracy: number,
): UserProgress {
  const existing = progress.lessonStats[lessonId];
  return {
    ...progress,
    completedLessons: progress.completedLessons.includes(lessonId)
      ? progress.completedLessons
      : [...progress.completedLessons, lessonId],
    lessonStats: {
      ...progress.lessonStats,
      [lessonId]: {
        bestWpm: existing ? Math.max(existing.bestWpm, wpm) : wpm,
        bestAccuracy: existing ? Math.max(existing.bestAccuracy, accuracy) : accuracy,
        completedAt: new Date().toISOString(),
      },
    },
  };
}
